<template>
	<div class="img-wrap text-center">
		<audio :src="pathView" :autoplay="autoPlay" controls controlsList="nodownload"></audio>
	</div>
</template>

<script>
	// import { APP_CONFIG } from '@/utils/constants'

	export default {
		name: 'PreviewAudio',
		props: {
      pathView: String,
      autoPlay: Boolean,
      viewItem: Boolean
    },
		data() {
			return {
				// appUrl: APP_CONFIG.appUrl,
				// urlCmsImg: APP_CONFIG.urlCmsImg
			}
		},
		methods: {
			idVideoYoutube(link) {
				return link.split('?v=')[1];
			}
		}
	}
</script>

<style lang="scss" scoped>
audio {
  max-width: 100%;
}
</style>